export default "__VITE_ASSET__CW$KeR6G__"